module.exports = __webpack_public_path__ + "static/media/Impreza-Blob-GG-Wagon.0afa0603.webp";